import type { AppSelectOption } from '../components/AppSelect';

/** Einheiten für Angebote / Leistungen (identisch zu früher LeistungenSection). */
export const OFFER_UNIT_OPTIONS: AppSelectOption[] = [
  { value: '', label: 'Bitte wählen…' },
  { value: 'Stk', label: 'Stk' },
  { value: 'm', label: 'm' },
  { value: 'm²', label: 'm²' },
  { value: 'm³', label: 'm³' },
  { value: 'kg', label: 'kg' },
  { value: 'l', label: 'l' },
  { value: 'h', label: 'h' },
  { value: 'Std', label: 'Std' },
  { value: 'Pauschal', label: 'Pauschal' },
];

export const OFFER_STANDARD_UNIT_VALUES = new Set(
  OFFER_UNIT_OPTIONS.map((o) => o.value).filter((v) => v.length > 0)
);

/** Zeilen mit alter/freier Einheit behalten den Wert als zusätzliche Option. */
export function offerUnitSelectOptions(currentUnit: string | null): AppSelectOption[] {
  const u = currentUnit?.trim() ?? '';
  if (u && !OFFER_STANDARD_UNIT_VALUES.has(u)) {
    return [{ value: u, label: u }, ...OFFER_UNIT_OPTIONS];
  }
  return OFFER_UNIT_OPTIONS;
}
